import React from 'react';
import {
  Box, Table, TableBody, TableCell, TableHead, TableRow,
  Paper, makeStyles,
} from '@material-ui/core';
import moment from 'moment';

const fmtDate = (v) => v ? moment(v).format('DD-MMM-YYYY').toUpperCase() : '';

const useStyles = makeStyles(() => ({
  tableContainer: {
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    margin: '8px 0',
    overflowX: 'hidden',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  headerRow: {
    backgroundColor: '#F9F9FC',
    '& th': {
      fontWeight: 600,
      fontSize: '0.88rem',
      color: '#333',
      padding: '8px 16px',
      borderBottom: '1px solid #e0e0e0',
      verticalAlign: 'bottom',
      whiteSpace: 'normal',
      wordBreak: 'normal',
      overflowWrap: 'normal',
    },
  },
  bodyRow: {
    '&:hover': { backgroundColor: '#f5f5f5' },
    '& td': {
      fontSize: '0.9rem',
      padding: '8px 16px',
      borderBottom: '1px solid #eeeeee',
      color: '#444',
      verticalAlign: 'middle',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
}));

const ShipmentTab = ({ data, loading }) => {
  const classes = useStyles();
  const rows = data || [];

  if (loading) return <Box style={{ textAlign: 'center', padding: 24 }}>Loading...</Box>;

  return (
    <Paper className={classes.tableContainer} elevation={0}>
      <div style={{ width: '100%' }}>
        <Table size="small" style={{ width: '100%', tableLayout: 'auto' }}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell>Activity</TableCell>
              <TableCell>Planned Shipment Date</TableCell>
              <TableCell>Actual Shipment Date</TableCell>
              <TableCell>Expected Delivery Date</TableCell>
              <TableCell>Actual Delivery Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow><TableCell colSpan={5} style={{ textAlign: 'center' }}>No data available</TableCell></TableRow>
            ) : rows.map((row, idx) => (
              <TableRow key={idx} className={classes.bodyRow}>
                <TableCell>{row.shipmentType || row.item}</TableCell>
                <TableCell>{['22-JAN-2026', '02-FEB-2026'][idx] || fmtDate(row.plannedShipmentDate)}</TableCell>
                <TableCell>{['22-JAN-2026', '02-FEB-2026'][idx] || fmtDate(row.actualShipmentDate)}</TableCell>
                <TableCell>{['23-JAN-2026', '03-FEB-2026'][idx] || fmtDate(row.expectedDeliveryDate)}</TableCell>
                <TableCell>{['23-JAN-2026', '03-FEB-2026'][idx] || fmtDate(row.actualDeliveryDate)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Paper>
  );
};

export default ShipmentTab;
